import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutGrid, Plug, LogOut, Rocket } from "lucide-react";
import { cn } from "@/lib/utils";

const NAV = [
  { to: "/", label: "Projects", icon: LayoutGrid, testid: "nav-projects" },
  { to: "/connections", label: "Connections", icon: Plug, testid: "nav-connections" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/login");
  };

  const isActive = (to) => (to === "/" ? location.pathname === "/" : location.pathname.startsWith(to));

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <div className="flex">
        {/* Sidebar */}
        <aside className="hidden md:flex w-64 flex-col border-r border-[#262626] min-h-screen sticky top-0 p-6">
          <Link to="/" className="flex items-center gap-2 mb-10" data-testid="brand-logo">
            <div className="h-8 w-8 rounded-md bg-white flex items-center justify-center">
              <Rocket className="h-4 w-4 text-black" strokeWidth={2} />
            </div>
            <span className="font-heading text-lg font-bold tracking-tight">DeployBridge</span>
          </Link>
          <nav className="flex flex-col gap-1">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={n.testid}
                className={cn(
                  "flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors duration-200",
                  isActive(n.to) ? "bg-[#1F1F1F] text-white" : "text-neutral-400 hover:bg-[#141414] hover:text-white"
                )}
              >
                <n.icon className="h-4 w-4" strokeWidth={1.5} />
                {n.label}
              </Link>
            ))}
          </nav>
          <div className="mt-auto pt-6 border-t border-[#262626]">
            <div className="text-xs text-neutral-500 mb-2 truncate" data-testid="sidebar-user-email">
              {user?.email}
            </div>
            <button
              onClick={onLogout}
              data-testid="logout-button"
              className="flex items-center gap-2 text-sm text-neutral-400 hover:text-white transition-colors duration-200"
            >
              <LogOut className="h-4 w-4" strokeWidth={1.5} /> Log out
            </button>
          </div>
        </aside>

        {/* Main */}
        <main className="flex-1 min-w-0">
          <div className="md:hidden flex items-center justify-between border-b border-[#262626] px-4 py-3">
            <Link to="/" className="flex items-center gap-2">
              <Rocket className="h-5 w-5" />
              <span className="font-heading font-bold">DeployBridge</span>
            </Link>
            <button onClick={onLogout} className="text-neutral-400"><LogOut className="h-4 w-4" /></button>
          </div>
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">{children}</div>
        </main>
      </div>
    </div>
  );
}
